import { render, staticRenderFns } from "./CartsLog.vue?vue&type=template&id=0d0ab22e&"
import script from "./CartsLog.vue?vue&type=script&lang=js&"
export * from "./CartsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports